import { create } from "zustand";
import { ExamStoreTypes } from "./storeTypes/examStoreTypes";
import {
  ExamCenterListInterface,
  ExamGroupItemTypes,
  ExamGroupListTypesMain,
  ExamSlotsTypes,
  ExamStatus,
  SpecificCenterAllotmentTypesMain,
  StepExamInterface,
  ViewExamResponseTypes,
  ViewResultDetailsTypes,
} from "../interfaces/exam.interface";

const useExamStore = create<ExamStoreTypes>((set) => ({
  examStepChecker: {
    QuestionAssignmentStep: null,
    QuestionSetAndCombination: null,
    examSlotCreation: null,
    assignExamCentreAndAllottQuestionSet: null,
    allottQuestionSet: null,
  },
  setExamSteoChecker: (data: {
    QuestionAssignmentStep: StepExamInterface | null;
    QuestionSetAndCombination: StepExamInterface | null;
    examSlotCreation: StepExamInterface | null;
    assignExamCentreAndAllottQuestionSet: StepExamInterface | null;
    allottQuestionSet: StepExamInterface | null;
  }) => set(() => ({ examStepChecker: data })),
  globalExamModal: false,
  setGlobalExamModal: (data: boolean) => set(() => ({ globalExamModal: data })),
  selectedPaperForExam: [],
  examGroupList: null,
  setExamGroupList: (data: ExamGroupListTypesMain | null) =>
    set(() => ({ examGroupList: data })),
  setSelectedExamPaperForExam: (data: Array<any>) =>
    set(() => ({ selectedPaperForExam: data })),
  examResult: undefined,
  setExamResult: (data: ViewResultDetailsTypes | undefined) =>
    set(() => ({ examResult: data })),
  specificCenterUserList: null,
  setSpecificCenterList: (data: SpecificCenterAllotmentTypesMain | null) =>
    set(() => ({ specificCenterUserList: data })),
  centerUserList: [],
  setCenterUserList: (data: Array<ExamCenterListInterface>) =>
    set(() => ({ centerUserList: data })),
  creationExamErrorMessage: "",
  setCreationExamErrorMessage: (data: string) =>
    set(() => ({ creationExamErrorMessage: data })),
  selectedExamGlobally: null,
  setSelectedExamGlobally: (data: ExamGroupItemTypes | null) =>
    set(() => ({ selectedExamGlobally: data })),
  questionLengthStatus: -1,
  setQuestionLengthStatus: (data: number) =>
    set(() => ({ questionLengthStatus: data })),
  CandidateLengthStatus: -1,
  setCandidateLengthStatus: (data: number) =>
    set(() => ({ CandidateLengthStatus: data })),
  examCreationStatus: -1,
  setExamCreationStatus: (data: number) =>
    set(() => ({ examCreationStatus: data })),
  currentExamId: -1,
  setCurrentExamId: (data: number) => set(() => ({ currentExamId: data })),
  examDetails: null,
  setExamDetails: (data: any) => set(() => ({ examDetails: data })),
  createExamSlot: null,
  setCreateExamSlot: (data: any) => set(() => ({ createExamSlot: data })),
  defaultExamsList: {
    count: 0,
    page_index: 0,
    page_size: 0,
    resp: [],
  },
  setDefaultExamsList: (data: ViewExamResponseTypes) =>
    set(() => ({ defaultExamsList: data })),
  examStatus: undefined,
  setExamStatus: (data: ExamStatus | null | undefined) =>
    set(() => ({ examStatus: data })),
  examSlotResponse: null,
  setviewExams: (data: ViewExamResponseTypes) =>
    set(() => ({ viewExams: data })),
  viewExams: {
    count: 0,
    page_index: 0,
    page_size: 0,
    resp: [],
  },
  proctoringresultLoading: false,
  setProctoringResultLoading: (data: boolean) =>
    set(() => ({ proctoringresultLoading: data })),
  selectedExamPapers: [],
  setSelectedExamPaper: (data: Array<any>) =>
    set(() => ({ selectedExamPapers: data })),
  setSidebarExams: (data: Array<ExamGroupItemTypes>) =>
    set(() => ({ sidebarExams: data })),
  sidebarExams: [],
  setExamSlotResponse: (data: ExamSlotsTypes | null) =>
    set(() => ({ examSlotResponse: data })),
}));

export default useExamStore